import { PREDEFINED_BLUEPRINT_TYPES } from './constants.ts';

export const getBlueprintType = (content: any): string => {
	const labels = content?.metadata?.labels ?? [];

	const blueprintLabel = labels.find((item) => {
		if (item?.name) {
			return PREDEFINED_BLUEPRINT_TYPES[item.name];
		}
	});

	return blueprintLabel?.name ?? '';
};
